__turbopack_context__.v({
  "description": "home-module-scss-module__rU4D2W__description",
  "homeWrp": "home-module-scss-module__rU4D2W__homeWrp",
  "intro": "home-module-scss-module__rU4D2W__intro",
  "support": "home-module-scss-module__rU4D2W__support",
});
